import getGeneralOptions from './bar-graph-stacked-general-options';

export const getMobileOptions = (graphConstants) => {
  const generalOptions = getGeneralOptions(graphConstants);
  return {
    ...generalOptions,
    layout: {
      padding: {
        ...generalOptions.layout.padding,
        left: 0,
        right: 0,
      },
    },
  };
};

export const getDesktopOptions = (graphConstants) => {
  const generalOptions = getGeneralOptions(graphConstants);
  return {
    ...generalOptions,
  };
};

export const getDataDefaults = (graphConstants) => {
  const { dataSet1, dataSet2, dataSet3, defaultFontFamily } = graphConstants;
  return {
    datasets: [
      {
        label: dataSet1.label,
        backgroundColor: dataSet1.color,
        datalabels: {
          anchor: 'end',
          align: 'top',
          formatter: () => '',
          color: dataSet1.color,
          font: {
            size: 24,
            weight: 'bold',
            family: defaultFontFamily,
          },
        },
      },
      {
        label: dataSet2.label,
        backgroundColor: dataSet2.color,
        datalabels: {
          anchor: 'end',
          align: 'top',
          formatter: (value, context) => (context.dataIndex !== 0 ? `${value}%` : ''),
          color: dataSet2.color,
          font: {
            size: 24,
            weight: 'bold',
            family: defaultFontFamily,
          },
        },
      },
      {
        label: dataSet3.label,
        backgroundColor: dataSet3.color,
        datalabels: {
          anchor: 'end',
          align: 'top',
          color: dataSet1.color,
          font: {
            size: 24,
            weight: 'bold',
            family: defaultFontFamily,
          },
        },
      },
    ],
  };
};

